import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import IOSIconPNG from '../../../Assets/appleIcon.png';
import sendFirebaseEvent from '../../../analytics/FirebaseAnalytics';
import { submitFeedbackToSheet } from '../../../app/API';
import { CANONICAL_SITE_URL } from '../../../config/canonicalSite';

const Footer = () => {

    const [activeSection, setActiveSection] = useState('home');
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackName, setFeedbackName] = useState('');
    const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);
    const [feedbackSent, setFeedbackSent] = useState(false);
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [contactName, setContactName] = useState('');
    const [contactPhone, setContactPhone] = useState('');
    const [contactMessage, setContactMessage] = useState('');
    const [contactSubmitting, setContactSubmitting] = useState(false);
    const [contactSent, setContactSent] = useState(false);
    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        // setMenuOpen(false); // Close menu after clicking (for mobile)
    };

    // Function to detect which section is currently in view
    const handleSectionChange = () => {
        const sections = ['home', 'numbers', 'about-us', 'features', 'phone-screens', 'contact-us', 'testimonials'];
        const scrollPosition = window.scrollY;

        for (let i = 0; i < sections.length; i++) {
            const section = document.getElementById(sections[i]);
            if (section) {
                const sectionTop = section.offsetTop - 100; // Offset to account for padding
                const sectionHeight = section.clientHeight;

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                    setActiveSection(sections[i]);
                    break;
                }
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleSectionChange);
        return () => {
            window.removeEventListener('scroll', handleSectionChange);
        };
    }, []);

    const handleSendFeedback = async () => {
        const message = (feedbackMessage || '').trim();
        const name = (feedbackName || '').trim();
        if (!message) return;
        setFeedbackSubmitting(true);
        setFeedbackSent(false);
        try {
            sendFirebaseEvent('Send Feedback', 'Footer', 'click', 'click on send feedback');
            await submitFeedbackToSheet({ name, message, source: 'footer' });
            setFeedbackMessage('');
            setFeedbackName('');
            setFeedbackSent(true);
        } catch (err) {
            console.error('Failed to send feedback', err);
        } finally {
            setFeedbackSubmitting(false);
        }
    };

    const handleContactSubmit = async () => {
        const name = (contactName || '').trim();
        const phone = (contactPhone || '').trim();
        const message = (contactMessage || '').trim();
        if (!name || !phone || !message) return;
        if (phone.length !== 10 || !/^[0-9]+$/.test(phone)) return;
        setContactSubmitting(true);
        setContactSent(false);
        try {
            sendFirebaseEvent('Contact Us', 'Modal', 'submit', 'submit contact form');
            await submitFeedbackToSheet({ name, phone, message, source: 'contact-us' });
            setContactName('');
            setContactPhone('');
            setContactMessage('');
            setContactSent(true);
        } catch (err) {
            console.error('Failed to send contact', err);
        } finally {
            setContactSubmitting(false);
        }
    };

    const closeContactModal = () => {
        setContactModalOpen(false);
        if (contactSent) {
            setContactSent(false);
        }
    };

    return (
        <Container>
            <UpperSection>
                <Line />
                <LinkSection>
                    {/* <SocialContainer>
                        <a>
                            <SocialIMG src={InstaIconPNG} />
                        </a>
                        <a>
                            <SocialIMG style={{ width: "34px", height: "21px" }} src={MetaIconPNG} />
                        </a>
                    </SocialContainer> */}

                    <HeaderLinks>
                        <Link style={{ fontWeight: "600" }}>Home
                            <div style={{ width: "40px", background: "linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%)", height: "2px" }}></div>
                        </Link>
                        <Link onClick={() => {
                            handleScroll('about-us');
                            sendFirebaseEvent('Footer', 'About Us', 'click', 'click on about us');
                        }}>About Us</Link>
                        <Link onClick={() => {
                            handleScroll('features');
                            sendFirebaseEvent('Footer', 'Features', 'click', 'click on features');
                        }}>Features</Link>
                        <Link onClick={() => {
                            handleScroll('subscription');
                            sendFirebaseEvent('Footer', 'Subscription', 'click', 'click on subscription');
                        }}>Subscription</Link>
                        <Link onClick={() => {
                            setContactModalOpen(true);
                            sendFirebaseEvent('Footer', 'Contact Us', 'click', 'click on contact us');
                        }}>Contact Us</Link>
                        <Link onClick={() => {
                            handleScroll('testimonials');
                            sendFirebaseEvent('Footer', 'Testimonials', 'click', 'click on testimonials');
                        }}>Testimonials</Link>
                        <ParentSiteFooterLink
                            href={`${CANONICAL_SITE_URL}/extra/privacy-policy`}
                            target="_parent"
                            rel="noopener noreferrer"
                        >
                            Privacy Policy
                        </ParentSiteFooterLink>
                        <ParentSiteFooterLink
                            href={`${CANONICAL_SITE_URL}/extra/Terms-and-conditions`}
                            target="_parent"
                            rel="noopener noreferrer"
                        >
                            Terms & Conditions
                        </ParentSiteFooterLink>
                        <ParentSiteFooterLink
                            href={`${CANONICAL_SITE_URL}/extra/refund-register`}
                            target="_parent"
                            rel="noopener noreferrer"
                        >
                            Refund Policy
                        </ParentSiteFooterLink>
                    </HeaderLinks>
                </LinkSection>
                <Line />
            </UpperSection>
            <LowerSection>
                <ButtonContainer>
                    <Button onClick={() => {
                        window.open('https://play.google.com/store/apps/details?id=com.kwikmedia&hl=en', '_blank');
                        sendFirebaseEvent('Download Android', 'Footer', 'click', 'click on download android');
                    }}>For Android</Button>
                    <Button onClick={() => {
                        window.open('https://apps.apple.com/in/app/kwikmedia/id6717602527', '_blank');
                        sendFirebaseEvent('Download IOS', 'Footer', 'click', 'click on download ios');
                    }}>
                        <img src={IOSIconPNG} style={{ width: "25px", height: "30px", marginRight: "8px" }} />
                        For IOS</Button>
                </ButtonContainer>
                <SearchContainer>
                    <SearchBar >
                        <SearchInput
                            placeholder='Your name'
                            value={feedbackName}
                            onChange={(e) => setFeedbackName(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && document.getElementById('footer-feedback-msg')?.focus()}
                            disabled={feedbackSubmitting}
                            style={{ flex: '0 0 100px' }}
                        />
                        <SearchInput
                            id='footer-feedback-msg'
                            placeholder='Send feedback'
                            value={feedbackMessage}
                            onChange={(e) => setFeedbackMessage(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSendFeedback()}
                            disabled={feedbackSubmitting}
                            style={{ flex: 1 }}
                        />
                        <SendButton
                            onClick={handleSendFeedback}
                            disabled={feedbackSubmitting || !feedbackMessage.trim()}
                        >
                            {feedbackSubmitting ? '...' : feedbackSent ? 'Sent' : 'Send'}
                        </SendButton>
                    </SearchBar>
                </SearchContainer>
            </LowerSection>
            <CornerCredit>A Ventureboo LLP product</CornerCredit>

            {contactModalOpen && (
                <ContactModalOverlay onClick={closeContactModal}>
                    <ContactModalContent onClick={(e) => e.stopPropagation()}>
                        <ContactModalTitle>Contact Us</ContactModalTitle>
                        {contactSent ? (
                            <ContactSuccessMessage>
                                Thank you! We'll get back to you soon.
                            </ContactSuccessMessage>
                        ) : (
                            <>
                                <ContactField>
                                    <ContactLabel>Name</ContactLabel>
                                    <ContactInput
                                        placeholder="Your name"
                                        value={contactName}
                                        onChange={(e) => setContactName(e.target.value)}
                                        disabled={contactSubmitting}
                                    />
                                </ContactField>
                                <ContactField>
                                    <ContactLabel>Phone number</ContactLabel>
                                    <ContactInput
                                        type="tel"
                                        placeholder="10-digit phone number"
                                        value={contactPhone}
                                        onChange={(e) => setContactPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                        disabled={contactSubmitting}
                                        maxLength={10}
                                    />
                                </ContactField>
                                <ContactField>
                                    <ContactLabel>Message</ContactLabel>
                                    <ContactTextarea
                                        placeholder="Your message"
                                        value={contactMessage}
                                        onChange={(e) => setContactMessage(e.target.value)}
                                        disabled={contactSubmitting}
                                        rows={4}
                                    />
                                </ContactField>
                                <ContactError>
                                    {contactPhone && contactPhone.length !== 10 && 'Please enter a valid 10-digit phone number.'}
                                </ContactError>
                            </>
                        )}
                        <ContactButtonRow>
                            <ContactCancelButton onClick={closeContactModal}>
                                {contactSent ? 'Close' : 'Cancel'}
                            </ContactCancelButton>
                            {!contactSent && (
                                <ContactSubmitButton
                                    onClick={handleContactSubmit}
                                    disabled={contactSubmitting || !contactName.trim() || contactPhone.length !== 10 || !contactMessage.trim()}
                                >
                                    {contactSubmitting ? 'Sending...' : 'Send'}
                                </ContactSubmitButton>
                            )}
                        </ContactButtonRow>
                    </ContactModalContent>
                </ContactModalOverlay>
            )}
        </Container >
    )
}

export default Footer;
const Container = styled.div`
width:100%;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
margin-top:100px;
margin-bottom:50px;
`;

const UpperSection = styled.div`
width:80%


`;

const LinkSection = styled.div`
width:100%;
margin:30px 0px;
display:flex;

@media (max-width:1000px){
flex-direction:column-reverse;
}
`;

const SocialContainer = styled.div`
width:20%;

@media (max-width:1000px){
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-top:30px;
}
`;
const HeaderLinks = styled.div`
width:100%;
display:flex;
align-items: center;
justify-content: space-evenly;
gap:8px;
@media (max-width:1215px){
flex-direction:column;
width:100%;
}

`;

const Link = styled.div`
font-family: Urbanist;
font-size: 20px;
font-weight: 400;
background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
background-clip: text;
color: transparent;
cursor:pointer;
@media (max-width:1000px){
    margin-top:20px;
}
`;

const ParentSiteFooterLink = styled.a`
font-family: Urbanist;
font-size: 20px;
font-weight: 400;
background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
background-clip: text;
color: transparent;
cursor: pointer;
text-decoration: none;
@media (max-width:1000px){
    margin-top:20px;
}
`;
const SocialIMG = styled.img`
width:20px;
height:20px;
margin-right:10px
`;
const Line = styled.div`
width:100%;
height:1px;
background-color:gray;
`;

const LowerSection = styled.div`
margin-top:30px;
display: flex;
width:80%;


@media (max-width:1000px){
 flex-direction: column-reverse;
}
`;

const ButtonContainer = styled.div`
width:50%;
display: flex;
justify-content:space-evenly;

@media (max-width:1000px){
 width:100%;
 margin-top:30px;
 gap:10px
}
`;

const Button = styled.button`
width: 250px;
height: 56px;
border-radius: 50px ;
color:white;
border:none;
background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%);
font-family: Urbanist;
font-size: 23px;
font-weight: 500;
cursor: pointer;
display:flex;
align-items: center;
justify-content: center;
@media (max-width:1000px){
 width:150px;
 font-size: 16px;
}
`
const SearchContainer = styled.div`
width:50%;
display: flex;
align-items:center;
justify-content:end;

@media (max-width:1000px){
 width:100%;
 justify-content:center;
}

`;

const CornerCredit = styled.div`
  width: 80%;
  margin-top: 24px;
  text-align: right;
  font-family: Urbanist;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.5);
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const SearchBar = styled.div`
width: 100%;
max-width: 420px;
height: 56px;
padding: 8px 10px 8px 28px;
border-radius: 30px;
border: 2px solid transparent; /* Important: transparent border first */
background: 
    linear-gradient(#fff, #fff) padding-box, /* background inside */
    linear-gradient(133.16deg, #FFC951 -4.52%, #CE56B0 107.63%) border-box; /* border gradient */
display: flex;
align-items: center;
justify-content: space-between;
gap: 8px;
`;
const SearchInput = styled.input`
border:none;
font-family: Urbanist;
font-size: 16px;
font-weight: 500;
min-width: 0;
background-color:transparent;

&:focus{
outline:none;
}
`;
const SendButton = styled.button`
width: 80px;
height: 40px;
border-radius: 46px;
background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 120%);
color:white;
border:none;
cursor:pointer;

&:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`;

/* ---------- Contact Us Modal ---------- */
const ContactModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ContactModalContent = styled.div`
  background: linear-gradient(144.01deg, #FFC951 0%, #C94DAA 100%);
  border-radius: 1rem;
  padding: 2rem;
  width: 100%;
  max-width: 420px;
  text-align: center;
  animation: fadeIn 0.3s ease;
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
`;

const ContactModalTitle = styled.h2`
  margin: 0 0 1.5rem 0;
  color: #fff;
  font-family: Urbanist;
  font-size: 1.5rem;
  font-weight: 600;
`;

const ContactField = styled.div`
  text-align: left;
  margin-bottom: 1rem;
`;

const ContactLabel = styled.label`
  display: block;
  color: rgba(255,255,255,0.95);
  font-family: Urbanist;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.35rem;
`;

const ContactInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 100px;
  border: none;
  font-family: Urbanist;
  font-size: 1rem;
  background: #F7F7F7;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #999;
  }
  &:disabled {
    opacity: 0.7;
  }
`;

const ContactTextarea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  border: none;
  font-family: Urbanist;
  font-size: 1rem;
  background: #F7F7F7;
  resize: vertical;
  min-height: 80px;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #999;
  }
  &:disabled {
    opacity: 0.7;
  }
`;

const ContactError = styled.div`
  color: #fff;
  font-size: 0.85rem;
  text-align: left;
  min-height: 1.2rem;
  margin-bottom: 0.25rem;
`;

const ContactSuccessMessage = styled.p`
  color: #fff;
  font-family: Urbanist;
  font-size: 1.1rem;
  margin: 0 0 1.5rem 0;
`;

const ContactButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.25rem;
`;

const ContactCancelButton = styled.button`
  border: none;
  border-radius: 100px;
  padding: 0.75rem 2rem;
  cursor: pointer;
  color: #fff;
  font-family: Urbanist;
  font-size: 1rem;
  font-weight: 600;
  background: rgba(255,255,255,0.3);
  &:hover {
    background: rgba(255,255,255,0.4);
  }
`;

const ContactSubmitButton = styled.button`
  background: #fff;
  border: none;
  border-radius: 100px;
  padding: 0.75rem 2rem;
  cursor: pointer;
  color: #333;
  font-family: Urbanist;
  font-size: 1rem;
  font-weight: 600;
  &:hover:not(:disabled) {
    transform: scale(1.02);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
